import AssignAgentsPage from "./assign-agents-page";

export default AssignAgentsPage;
